import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import SiteIcons from "@/components/SiteIcons/SiteIcons";
import "@/components/Loading/Loading.css";

function Loading() {
  const theme = useTheme();
  return (
    <Box id="loading-box">
      <SiteIcons
        iconstring="circular-loader"
        size="1.5rem"
        page="sitewide-loader"
      />
      <Typography variant="h6" color={theme.palette.primary.main}>
        Loading. . .{" "}
      </Typography>
    </Box>
  );
}

export default Loading;
